/* eslint-disable func-names */

const tabbedContainer = $('.tabbed-container');
let firstLoad;
let buttons;
let anchorLinks;
let anchors;
let tabs;

// Prevent error in IE 9 and 10
if (window.navigator.vendor === undefined) {
  window.navigator.vendor = '';
}

function setTabsWidth(tabsData) {
  tabsData.each(function() {
    $(this).css({
      'width': `${tabbedContainer.outerWidth()}px`, 'box-sizing': 'border-box'
    });
  });
}

function resizePrdPage(tabsData, buttonsData) {
  setTabsWidth(tabsData);
  if (typeof window.DCG.isitePlayerAPI === 'undefined') return;
  if (window.App.Platform.viewportWidth() > 1024 &&
    tabbedContainer.find('.tab-expanded').length < 1) {
    firstLoad = true;
    buttonsData.filter(':first').click();
  }
}

function init() {
  firstLoad = true;
  buttons = tabbedContainer.find('.tab-toggle');
  anchorLinks = $('.anchor-lk');
  anchors = buttons.add(anchorLinks);
  tabs = tabbedContainer.find('.content');

  setTabsWidth(tabs, tabbedContainer);

  anchors.click(function(e) {
    e.preventDefault();
    const rel = $(this).attr('href').split('|');
    toggleTab(rel[0]);
  });

  if (typeof window.DCG !== 'undefined') {
    if (typeof window.DCG.pubsub === 'undefined') return;
    window.DCG.pubsub.on('resize', () => { resizePrdPage(tabs, buttons); });
  } else {
    $(window).on('resize', () => { resizePrdPage(tabs, buttons); });
  }
  buttons.filter(':first').click();
  firstLoad = false;
}

function toggleTab(tabId) {
  if (!tabId.match(/#tab\d+/g)) {
    return;
  }

  buttons = tabbedContainer.find('.tab-toggle');
  tabs = tabbedContainer.find('.content');
  const tab = $(tabId).find('.content');
  const relButtons = buttons.filter(function() {
    return $(this).attr('href') === tabId;
  });

  tabs.not(tab).removeClass('tab-expanded');
  buttons.removeClass('tab-active');

  tab.toggleClass('tab-expanded');
  if (tab.hasClass('tab-expanded')) {
    relButtons.addClass('tab-active');
  } else {
    relButtons.removeClass('tab-active');
  }

  if (firstLoad) {
    $(document).ready(() => {
      $('html, body').scrollTop(0);
      firstLoad = false;
    });
  } else {
    const panelHeight =
      (window.App.Platform.viewportWidth() > 1024) ? 0 : 100;
    const pos = ($(tabId).offset().top - panelHeight);
    $('html, body').stop().animate({ scrollTop: pos });
  }
}

function loadCSSForReevooAfterPageLoad() {
  const reevooTab = tabbedContainer.find('.tabs-container .tab-content.tab-reviews');

  // if reevoo Reviews tab is present on the page, load CSS for Reevoo after page load
  if (reevooTab.length > 0) {
    window.addEventListener('load', (event) => {
      const styles = document.createElement('link');
      styles.rel = 'stylesheet';
      styles.type = 'text/css';
      styles.media = 'screen';
      styles.href = '//mark.reevoo.com/stylesheets/reevoomark/embedded_reviews.css';
      document.getElementsByTagName('head')[0].appendChild(styles);
    });
  }
}

module.exports = {
  init: init,
  toggleTab: toggleTab,
  loadCSSForReevooAfterPageLoad: loadCSSForReevooAfterPageLoad
};
